export const ControlTypes = {
  text: 1,
  DDRS_ID: 6,
  DDRS_Member: 7
};
